import {
  formatUiDate,
  formatUiDateTime,
  formatUiMonthYear,
  formatUiTime,
} from './uiFormat';

export const getDateFormat = () => 'DAY, DD-MMM-YYYY';

export const formatDate = (value) => formatUiDate(value);

export const formatDateWithWeekday = (value) => formatUiDate(value);

export const formatTime = (value, { seconds = false } = {}) => (
  formatUiTime(value, { seconds })
);

export const formatDateTime = (value, { seconds = false, weekday = false } = {}) => (
  formatUiDateTime(value, { seconds, separator: ' ' })
);

export const formatMonthYear = (value) => formatUiMonthYear(value);

export const toIsoDateString = (value) => {
  if (!value) return '';
  const date = value instanceof Date ? new Date(value) : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
};
